import { useMemo } from "react";
import bondSecuritiesStore from "@/store/bondSecuritiesStore";
import { findBondSecurityByIsin } from "@/store/bondSecuritiesStoreACTIONS";
import tradeFromScratchStore, {
  IRepoTicket,
  returnEmptyRepoTicket,
} from "@/store/tradeFromScratchStore";
import {
  REPO_TICKET_REQUIRED_KEYS,
  returnMissingRepoTicketEntries,
  returnRepoDateIssue,
} from "../helper/repoTicketHelper";

// One repo ticket by id: the stored ticket, its updater and what derives from it.
export function useRepoTicket(ticketId: string) {
  const storedTicket = tradeFromScratchStore(
    (state) => state.repoTicketsByTicketId[ticketId],
  );
  const updateTicket = tradeFromScratchStore((state) => state.updateRepoTicket);
  // Subscribed so the ticket re-renders if the securities land after it mounts.
  bondSecuritiesStore((state) => state.bondSecurities);

  const emptyTicket = useMemo(() => returnEmptyRepoTicket(), []);
  const ticket = storedTicket ?? emptyTicket;

  return {
    ticket,
    updateRepoTicket: (changes: Partial<IRepoTicket>) =>
      updateTicket(ticketId, changes),
    collateral: findBondSecurityByIsin(ticket.isin),
    missingEntries: returnMissingRepoTicketEntries(ticket),
    dateIssue: returnRepoDateIssue(ticket),
    requiredKeys: REPO_TICKET_REQUIRED_KEYS,
  };
}
